<template>
  <div></div>
</template>
<script>
export default {
  data() {
  },
  async mounted() {
    this.$router.replace('/cover?state=JvO5sRhOiR7');
  }
}
</script>